export default "./images/loading.mp4";